import {
  DTNode,
  DTStoreNode,
  StoreNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {ServerNode} from 'common/src/modules/nodes/nodes.types';
import {trimDescription} from 'common/src/modules/campaigns/utils/trimDescription';

export function serializeStoreNode(node: DTNode, newNode: ServerNode) {
  const storeNode = node as DTStoreNode;

  return {
    ...newNode,
    description: trimDescription(newNode.description),
    locationFeedId: storeNode.locationFeedId,
    locationTargetingMethod: storeNode.locationTargetingMethod,
    locationSetId: storeNode.locationSetId,
    maxDistKm: storeNode.maxDistKm,
    maxDistFallbackOption: storeNode.maxDistFallbackOption,
    topLocationIds: storeNode.topLocationIds,
    outputs: (node.outputs as StoreNodeOutputData[]).map((output) => {
      return {nodeId: output.nodeId, type: output.type, id: output.id};
    }),
    feedDescription: storeNode.feedDescription,
  };
}

